import React from 'react';
import { Link } from 'react-router-dom'; // Ensure you're using react-router for navigation

const Blog = () => {
  // Sample data for articles
  const articles = [
    {
      id: 1,
      imageSrc: '/Cats.jpg',
      topic: "Decoding Your Cat's Body Language",
    },
    {
      id: 2,
      imageSrc: '/Vaccination.webp',
      topic: 'Guide to Vaccinations for Dogs and Cats',
    },
    {
      id: 3,  
      imageSrc: '/Travel.jpg',
      topic: 'Tips for Safe and Stress-Free Adventures',
    },
    {
      id: 4,  
      imageSrc: '/Vet-visit.jpg',
      topic: 'Common Signs Your Pet Needs to See a Vet',
    },
    {
      id: 5,  
      imageSrc: '/Pet-food.jpg',
      topic: 'Pet Nutrition 101: What Should Your Pet Eat?',
    },
    {
      id: 6,  
      imageSrc: '/Lifestyle.jpeg',
      topic: 'choosing the Right Pet for Your Lifestyle',
    },
    // Add more articles as needed
  ];

  return (
    <section className="blog-section">
      <div className="container">
        <h2 className="section-heading">Latest Articles</h2>
        <div className="article-cards">
          {articles.map((article) => (
            <Link key={article.id} to={`/article/${article.id}`} className="article-card">
              <img src={article.imageSrc} alt={article.topic} className="article-image" />
              <div className="article-topic">{article.topic}</div> {/* Topic below the image */}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
